import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { faSpinner } from '@fortawesome/fontawesome-pro-regular';

@Component({
  standalone: false,
  selector: 'app-declarations-landing',
  templateUrl: './declarations-landing.component.html',
  styleUrls: ['./declarations-landing.component.css']
})
export class DeclarationsLandingComponent implements OnInit {

  faSpinner = faSpinner;

  constructor(private route: ActivatedRoute, private router: Router) {}

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      const horse_show_id = params['horse_show_id'];
      if (horse_show_id) {
        this.router.navigate(['declarations/entry-list', horse_show_id]);
      } else {
        this.router.navigate(['declarations/select-horse-show']);
      }
    });
  }
}
